export const TIMEZONES = [
  { label: 'GMT-8', value: 'America/Anchorage', display_name: 'timezones.anchorage' },
  { label: 'GMT-7', value: 'America/Los_Angeles', display_name: 'timezones.los_angeles' },
  { label: 'GMT-7', value: 'America/Phoenix', display_name: 'timezones.phoenix' },
  { label: 'GMT-5', value: 'America/Chicago', display_name: 'timezones.chicago' },
  { label: 'GMT-4', value: 'America/Puerto_Rico', display_name: 'timezones.puerto_rico' },
  { label: 'GMT-4', value: 'America/Indiana/Indianapolis', display_name: 'timezones.indianapolis' },
  {
    label: 'GMT-3',
    value: 'America/Argentina/Buenos_Aires',
    display_name: 'timezones.buenos_aires'
  },
  { label: 'GMT-3', value: 'America/Sao_Paulo', display_name: 'timezones.sao_paulo' },
  { label: 'GMT-2:30', value: 'America/St_Johns', display_name: 'timezones.st_johns' },
  { label: 'GMT+0', value: 'Etc/GMT', display_name: 'timezones.utc' },
  { label: 'GMT+1', value: 'Europe/Lisbon', display_name: 'timezones.lisbon' },
  { label: 'GMT+2', value: 'Africa/Harare', display_name: 'timezones.harare' },
  { label: 'GMT+2', value: 'Europe/Paris', display_name: 'timezones.paris' },
  { label: 'GMT+3', value: 'Africa/Cairo', display_name: 'timezones.cairo' },
  { label: 'GMT+3', value: 'Africa/Addis_Ababa', display_name: 'timezones.addis_ababa' },
  { label: 'GMT+4', value: 'Asia/Yerevan', display_name: 'timezones.yerevan' },
  { label: 'GMT+5', value: 'Asia/Karachi', display_name: 'timezones.karachi' },
  { label: 'GMT+5:30', value: 'Asia/Kolkata', display_name: 'timezones.kolkata' },
  { label: 'GMT+6', value: 'Asia/Dhaka', display_name: 'timezones.dhaka' },
  { label: 'GMT+7', value: 'Asia/Ho_Chi_Minh', display_name: 'timezones.ho_chi_minh' },
  { label: 'GMT+8', value: 'Asia/Shanghai', display_name: 'timezones.shanghai' },
  { label: 'GMT+9', value: 'Asia/Tokyo', display_name: 'timezones.tokyo' },
  { label: 'GMT+9:30', value: 'Australia/Darwin', display_name: 'timezones.darwin' },
  { label: 'GMT+10', value: 'Australia/Sydney', display_name: 'timezones.sydney' },
  { label: 'GMT+11', value: 'Pacific/Guadalcanal', display_name: 'timezones.guadalcanal' },
  { label: 'GMT+12', value: 'Pacific/Auckland', display_name: 'timezones.auckland' },
  { label: 'GMT+13', value: 'Pacific/Apia', display_name: 'timezones.apia' }
];

export const INVALID_DATE = 'Invalid Date';

export const DATE_FORMAT_BRAZIL = 'DD/MM/YYYY';

export const DATE_FORMAT_IST = 'YYYY-MM-DD';

export const TIME_FORMAT_IST = 'HH:mm:ss';
